var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50 5c-24.898 0-45 20.199-45 45 0 24.898 20.102 45 45 45s45-20.102 45-45c0-24.801-20.102-45-45-45zm0.30078 40.699c-7 0-12.699-5.8008-12.699-12.699 0-7 5.6992-12.801 12.699-12.801 6.8984 0 12.5 5.6992 12.5 12.801-0.10156 7-5.6016 12.699-12.5 12.699zm7.5 3.8008c8.8984 0 15.102 7.1992 15.102 15.199v7.5c0 8.5-8.6992 9.8008-22.699 9.8008-14.199 0-22.898-1.3008-23-9.8008v-7.5c0-7.8008 6.3008-15.199 15.301-15.199z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpUser);
export default __webpack_public_path__ + "static/media/np_user.26aa5739bdce55fecf808709bfbc7c82.svg";
export { ForwardRef as ReactComponent };